import React from 'react';
import styles from './Safe.module.css';

// Image imports
import safeAsset1 from '../../../assets/safe-asset-1.png';
import safeAsset2 from '../../../assets/safe-asset-2.png';
import safeAsset3 from '../../../assets/safe-asset-3.png';

const Safe = () => {
  return (
    <section className={styles.safeSection}>
      <div className={styles.backgroundLayer}> 
        <div className={styles.leftAssets}>
          <img src={safeAsset1} alt="Asset 1" className={styles.asset1} />
          <img src={safeAsset2} alt="Asset 2" className={styles.asset2} />
        </div>
        <div className={styles.rightAsset}>
          <img src={safeAsset3} alt="Asset 3" className={styles.asset3} />
        </div>
      </div>

      <div className={styles.textLayer}>
        <h2 className={styles.topLine}>Community based vetting options</h2>
        <h1 className={styles.safeTitle}>SAFE</h1>
        <h2 className={styles.bottomLine}>A double verification system keeps our users safe <br/>from any kind of malicious intent</h2>
      </div>
    </section>
  );
};

export default Safe;
